<template lang="pug">
page(
    main-title="Информация о магазине"
)
    template(slot="right")
        .insales-logo-contaner(v-if="shop.cms_id == 'InSales'")
            img.insales-logo(src="/static/app/images/insales-logo.png")

    template(slot="description") Здесь можно также найти информацию по интеграции
        span.text-bold  магазина

    template(slot="second", v-if="mode.type === 'update'")
        installation-guide(v-if="!['InSales', 'Tilda Publishing'].includes(shop.cms_id)",
                           :token="shop.api_token")

    .panel
        .panel-body
            .row.margin-bottom-20(v-if="shop.cms_id == 'InSales'")
                .col-md-12
                    span(v-html="integrationInfo.text")
                    span(v-if="integrationInfo.provider")
                        | {{ integrationInfo.text ? 'Перейти к ' : 'Для интеграции магазина перейдите к ' }}
                        router-link(:to="{ name: integrationInfo.provider + 'Integration' }")
                            | информации по интеграции и расшиненным настройкам
                        | .
            .row.margin-bottom-20(v-if="shop.cms_id == 'Tilda Publishing'")
                .col-md-12
                    | Как интегрировать нас в <b>Тильду</b>? Очень просто! Вот
                    a(href="https://salesbeat.pro/integrations/tilda", target="_blank")  подробная документация
                    |  (с видеоинструкцией!).
                    br
                    | P.S. Если всё-таки возникнут сложности – поможем!

            .row
                .col-md-6
                    .vfl-field.form-group(:class="{'has-error': !validation.domain.valid}")
                        input.vfl-field(
                            type="text",
                            required="",
                            v-model='shop.domain',
                            @focus='validation.domain.valid = true',
                            @blur='onDomainBlur'
                        )
                        span.field-underline
                        label Ссылка на магазин
                    span.help-block.error(v-if="!validation.domain.valid")
                        | {{ validation.domain.message }}
                .col-md-6
                    field(
                        type="select",
                        label="CMS",
                        :item="cms",
                        search-path="/shops/cms/autocomplete/"
                    )

            template(v-if="mode.type === 'update'")
                .row
                    .col-md-6
                        .row
                            .col-md-12
                                .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                                    input(
                                        type="text",
                                        required="",
                                        :value="shop.api_token",
                                        readonly='',
                                        style="padding-left: 0!important;"
                                    )
                                    i.fa.fa-clipboard(
                                        style="cursor: pointer;",
                                        title="Скопировать",
                                        @click="copyToClipboard"
                                    )
                                    span.field-underline
                                    label API-токен
                        .row
                            .col-md-12
                                span.help-block
                                    i.ti-help-alt.text-primary
                                    |  Используется для установки виджета и/или для взаимодействия с нашим API
                    .col-md-6
                        .row
                            .col-md-12
                                .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                                    input(
                                        type="text",
                                        required="",
                                        :value="shop.secret_token",
                                        readonly='',
                                        style="padding-left: 0!important;"
                                    )
                                    i.fa.fa-clipboard(
                                        style="cursor: pointer;",
                                        title="Скопировать",
                                        @click="copyToClipboard"
                                    )
                                    span.field-underline
                                    label Secret-токен
                        .row
                            .col-md-12
                                span.help-block
                                    i.ti-help-alt.text-primary
                                    |  Используется при выгрузке заказов в службу доставки

                template(v-if="shop.cms_id === 'Tilda Publishing'")
                  div.row.margin-top-30(v-if="shop.cms_id === 'Tilda Publishing'")
                    div.col-md-12 Для отправки заказов в личные кабинеты служб доставки перейдите в
                      |  интерфейс Тильды (<a href="//tilda.cc">tilda.cc</a>), перейдите
                      |  в <b>"Настройки сайта"</b> > <b>"Формы"</b> > <b>"Webhook"</b> и вставьте
                      |  в поле "WEBHOOK URL":
                    div.col-md-12.margin-top-10
                      .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                        input(
                          type="text",
                          required="",
                          :value="`https://app.salesbeat.pro/tilda/webhook/${shop.secret_token}/order/create/`",
                          readonly='',
                          style="padding-left: 0!important;"
                        )
                        i.fa.fa-clipboard(
                          style="cursor: pointer;",
                          title="Скопировать",
                          @click="copyToClipboard"
                        )
                        span.field-underline
                        label WEBHOOK URL

                div.row(v-else)
                    .col-md-6
                        .row
                            .col-md-12
                                .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                                    input(
                                        type="text",
                                        required="",
                                        v-model='shop.notification_url',
                                        style="padding-left: 0!important;"
                                    )
                                    span.field-underline
                                    label <i>Url</i> для оповещений
                        .row
                            .col-md-12
                                span.help-block
                                    i.ti-help-alt.text-primary
                                    |  Данный <i>url</i> необходим для оповещения магазина об изменении статуса
                                    | заказа на доставку

                .row.margin-top-30.margin-bottom-20
                    .col-md-12
                        | Если Вы используете <b>выгрузку</b> заказов, необходимо заполнить данные об <b>отправителе</b>
                        | для служб доставки:

                .row.margin-bottom-20
                    .col-md-6
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0(
                                :class="{'has-error': !defaultSenderValidation.full_name.valid}"
                        )
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.full_name',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Полное имя отправителя
                        span.help-block.error(v-if="!defaultSenderValidation.full_name.valid")
                            | {{ defaultSenderValidation.full_name.message }}
                    .col-md-6
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0(
                                :class="{'has-error': !defaultSenderValidation.phone.valid}"
                        )
                            the-mask(
                                type='tel',
                                required="",
                                mask="+7 (###) ###-##-##",
                                v-model='defaultSender.phone',
                                @focus.native="phoneFocus"
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Телефон отправителя
                        span.help-block.error(v-if="!defaultSenderValidation.phone.valid")
                            | {{ defaultSenderValidation.phone.message }}
                .row.margin-bottom-20
                    .col-md-2(style="margin-top: 8px;")
                        b {{ defaultCityFrom.full_name }}
                    .col-md-4
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0(
                                :class="{'has-error': !defaultSenderValidation.courier.street.valid}"
                        )
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.courier.street',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Улица
                        span.help-block.error(v-if="!defaultSenderValidation.courier.street.valid")
                            | {{ defaultSenderValidation.courier.street.message }}
                    .col-md-1
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0(
                                :class="{'has-error': !defaultSenderValidation.courier.house.valid}"
                        )
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.courier.house',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Дом
                        span.help-block.error(v-if="!defaultSenderValidation.courier.house.valid")
                            | {{ defaultSenderValidation.courier.house.message }}
                    .col-md-1
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.courier.house_block',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Корпус
                    .col-md-2
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            the-mask(
                                required="",
                                mask="##:##",
                                v-model='defaultSender.courier.time_from',
                                style="padding-left: 0!important;",
                                @focus.native="selectInputContent",
                                @blur.native="setDefaultOnBlur('10:00', defaultSender.courier, 'time_from')"
                            )
                            span.field-underline
                            label Время забора заказа от
                    .col-md-2
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            the-mask(
                                required="",
                                mask="##:##",
                                v-model='defaultSender.courier.time_to',
                                style="padding-left: 0!important;",
                                @focus.native="selectInputContent",
                                @blur.native="setDefaultOnBlur('18:00', defaultSender.courier, 'time_to')"
                            )
                            span.field-underline
                            label И до
                .row
                    .col-md-3
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.courier.postalcode',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Почтовый индекс (о, да, Boxberry их очень любит)
                    .col-md-3
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.pvzs_by_delivery_service_code.boxberry',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label ID ПВЗ Boxberry
                    .col-md-3
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.pvzs_by_delivery_service_code.sdek',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label ID ПВЗ СДЭК
                    .col-md-3
                        .vfl-field.form-group.input-icon.input-icon-right.margin-bottom-0
                            input(
                                type="text",
                                required="",
                                v-model='defaultSender.pickpoint_order_description',
                                style="padding-left: 0!important;"
                            )
                            span.field-underline
                            label Описание вложимого (для PickPoint)
                .row.margin-bottom-20
                    .col-md-offset-3.col-md-6
                        span.help-block
                            i.ti-help-alt.text-primary
                            |  ID ПВЗ для передачи заказов в службу доставки


            button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
            button.btn.btn-o.btn-primary.margin-left-4.pull-right(@click.prevent="discard") Отмена
            button.btn.btn-o.btn-danger.pull-right(
                v-if="mode.type === 'update'",
                @click.prevent="remove"
            ) Удалить


</template>

<script>
import { mapState } from 'vuex';

import InstallationGuide from '@/components/shops/InstallationGuide';

import swal from 'sweetalert';

const defaultTimeFrom = '10:00';
const defaultTimeTo = '18:00';

export default {
    name: 'EditShop',
    props: {
        isNew: {
            type: Boolean,
            default: false
        }
    },
    components: {
        InstallationGuide
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('getIntegrationInfo')
                .then((integrationInfo) => this.integrationInfo = integrationInfo);

            this.shop = this.isNew ? {} : {...this.$store.state.localStorage.selectedShop};
            if (this.cms) {
                this.cms.value = this.shop.cms_id;
            }

            this.$store.dispatch('getDefaultSender')
                .then(defaultSender => {
                    this.defaultSender = {
                        ...defaultSender,
                        courier: {
                            ...defaultSender.courier,
                            time_from: defaultSender.courier.time_from || defaultTimeFrom,
                            time_to: defaultSender.courier.time_to || defaultTimeTo
                        }
                    };
                });

            this.$store.dispatch('getLoadingSettings')
                .then(({default_from_city_data}) => this.defaultCityFrom = default_from_city_data);
        },
        setEmptyShop() {
            this.shop = {};
        },
        save() {
            if (!this.validate() || !this.validateDefaultSender()) {
                return;
            }

            // TODO: сейчас нет времени разбирваться в косяке, но поправить нужно!
            if (typeof this.cms.value === 'string') {
                this.shop.cms_id = this.cms.value;
            } else {
                this.shop.cms_id = this.cms.value && this.cms.value.id;
            }

            this.$store.dispatch('saveShop', this.shop)
                .then(
                    ({ created, data }) => {
                        this.$store.commit('selectShop', data);
                        created && this.getDataHook();
                    },
                    (data) => {
                        if (data.errorMessage) alert(data.errorMessage);
                    }
                );

            // Если заполнено хотя бы одно из обязательных (вместе) полей, то сохраняем
            // P.S. Да, тоже считаю, что такое себе
            if (this.defaultSender.full_name) {
                this.$store.dispatch('saveDefaultSender', {
                    ...this.defaultSender,
                    city_id: this.defaultCityFrom.aoguid
                });
            }
        },
        validate() {
            let valid = true;

            for (let field in this.validation) {
                if (!this.shop[field]) {
                    this.validation[field] = {valid: false, message: 'Обязательно для заполнения'};
                    valid = false;
                } else {
                    this.validation[field] = {valid: true, message: null};
                }
            }
            return valid;
        },
        validateDefaultSender() {
            const requiredTogether = {
                full_name: true,
                phone: true,
                courier: {street: true, house: true}
            };

            function *iterateRequiredTogether() {
                for (const k in requiredTogether) {
                    if (requiredTogether[k] === true) {
                        yield {
                            value: this.defaultSender[k],
                            validation: this.defaultSenderValidation[k]
                        };
                    } else {
                        for (const innerK in requiredTogether[k]) {
                            yield {
                                value: this.defaultSender[k][innerK],
                                validation: this.defaultSenderValidation[k][innerK]
                            };
                        }
                    }
                }
            }
            iterateRequiredTogether = iterateRequiredTogether.bind(this);

            let hasEmptyValue = false;
            let hasFilledValue = false;
            for (const {value, validation} of iterateRequiredTogether()) {
                validation.valid = true;
                validation.message = '';

                if (!value) {
                    hasEmptyValue = true;
                } else {
                    hasFilledValue = true;
                }
            }
            // Считаем, что "отправитель" валиден, если
            //  * никакие из обязательных полей не заполнены (заполнение и не начинали)
            //  * заполены все из обязательных полей
            let valid = (hasFilledValue && !hasEmptyValue) || (hasEmptyValue && !hasFilledValue);
            if (!valid) {
                for (const {value, validation} of iterateRequiredTogether()) {
                    if (!value) {
                        validation.valid = false;
                        validation.message = 'Обязательно для заполнения';
                    }
                }
            }

            return valid;
        },
        copyToClipboard(event) {
            let input = event.target.parentNode.querySelector('input,textarea');
            input.select();

            document.execCommand('Copy');
        },
        onDomainBlur() {
            let domain = this.shop.domain;
            if (domain && !domain.startsWith('http://') && !domain.startsWith('https://')) {
                this.shop.domain = `http://${domain}`;
            }
        },
        markInvalid(errors) {
            for (let error of errors) {
                this.validation[error.field].valid = false;
                this.validation[error.field].message = error.message;
            }
        },
        selectInputContent(event) {
            event.target.select();
        },
        setDefaultOnBlur(defaultValue, field, key) {
            if (!field[key] || field[key].length < 4) {
                field[key] = defaultValue;
            } else {
                let value = field[key].replace(':', '');
                const hours = Math.min(Number(value.slice(0, 2)), 23);
                const minutes = Math.min(Number(value.slice(2, 4)), 59);
                field[key] = String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
            }
        },
        remove: async function() {
            const willDelete = await swal({
                title: 'Точно хотите удалить?',
                icon: 'warning',
                buttons: {
                    cancel: {
                        text: 'Отмена',
                        visible: true,
                        className: 'btn btn-o btn-default'
                    },
                    confirm: {
                        text: 'Удаляем',
                        value: true,
                        className: 'btn btn-o btn-danger'
                    }
                }
            });
            if (!willDelete) return;

            await this.$store.dispatch('deleteShop', this.shop)
                .catch(({success, errorMessage}) => {
                    swal({
                        icon: 'error',
                        dangerMode: true,
                        title: errorMessage,
                        buttons: {
                            confirm: {
                                text: 'Ок, понял-принял',
                                className: 'btn btn-o btn-default'
                            }
                        }
                    });
                });

            await this.$store.dispatch('getSelectedShop');
            this.getDataHook();
        },
        discard() {
            this.getDataHook();
        },
        phoneFocus() {
            if (!this.defaultSender.phone) {
                this.defaultSender.phone = '+7 (';
            }
        }
    },
    computed: {
        mode() {
            return {
                text: (this.shop.number || this.shop.number === 0) ? 'Настройки' : 'Добавление',
                type: (this.shop.number || this.shop.number === 0) ? 'update' : 'create'
            };
        }
    },
    data() {
        this.getDataHook();

        const shop = this.shop;
        const cmsId = this.shop.cms_id;
        const cms = {
            value: cmsId,
            valid: true
        };

        return {
            shop,
            cms,

            defaultSender: {
                full_name: null,
                phone: null,
                courier: {
                    street: null,
                    house: null,
                    house_block: null,
                    time_from: defaultTimeFrom,
                    time_to: defaultTimeTo,
                    postalcode: null
                },
                pvzs_by_delivery_service_code: {
                    sdek: null,
                    boxberry: null
                },
                pickpoint_order_description: null
            },

            validation: {
                // name: {valid: true, message: null},
                domain: {valid: true, message: null}
            },

            defaultSenderValidation: {
                full_name: {valid: true, message: null},
                phone: {valid: true, message: null},
                courier: {
                    street: {valid: true, message: null},
                    house: {valid: true, message: null}
                }
            },

            defaultCityFrom: {},

            integrationInfo: {}
        };
    }
};
</script>

<style>
.insales-logo-contaner {
     text-align: right;
}
.insales-logo {
    height: 42px;
    margin-top: -18px;
}
@media (max-width: 767px) {
    .insales-logo {
        margin-top: 9px;
    }
    .insales-logo-contaner {
         text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shops/EditShop.vue